import { CONSTANTS } from "@/constants";
import { PaginationResponse } from "@/interfaces/api.interface";
import { Property } from "@/interfaces/property.interface";
import { logger } from "../logger";

export const addToFavorites = async (
  id: string,
  token: string
): Promise<Response> => {
  const response = await fetch(`${CONSTANTS.API_URL}/favorites`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ propertyId: id }),
  });

  if (!response.ok) {
    logger.error("Failed to add to favorites");
    throw new Error("Failed to add to favorites");
  }

  return response;
};

export const getFavorites = async (
  token: string,
  page: number,
  size: number,
  lang: string
): Promise<PaginationResponse<Property>> => {
  const response = await fetch(
    `${CONSTANTS.API_URL}/favorites?limit=${size}&page=${page}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": lang,
      },
    }
  );

  if (!response.ok) {
    logger.error("Failed to fetch favorites");
    throw new Error("Failed to fetch favorites");
  }

  return await response.json();
};

export const removeFavorite = async (
  id: string,
  token: string
): Promise<Response> => {
  const response = await fetch(`${CONSTANTS.API_URL}/favorites/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    logger.error("Failed to remove favorite");
    throw new Error("Failed to remove favorite");
  }

  return response;
};
